import Rellax  from "rellax";

const parallax = () => {
    const rellax = new Rellax('.js_parallax', {
        speed: -9,
        center: true,
    });
}

export default parallax;